import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransactionssettingssimplifiinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M17.5 21h-11a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M14 7.5h2m-2 3h2M8 15h8m-8 3h8M9.5 6.75V6m0 5.25V12m-1.302-1.286c.194.318.526.538.927.538h.822a1.053 1.053 0 0 0 .256-2.075l-1.406-.352a1.055 1.055 0 0 1 .256-2.075h.822c.4 0 .731.219.925.536"
	})]
});
export default SvgTransactionssettingssimplifiinline;
